/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAnnouncement } from '../../models/api-response-paged-result-announcement';
import { PagedRequestAnnouncementSearchReq } from '../../models/paged-request-announcement-search-req';

export interface GetListAnnouncement$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAnnouncementSearchReq
}

export function getListAnnouncement(http: HttpClient, rootUrl: string, params: GetListAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAnnouncement>> {
  const rb = new RequestBuilder(rootUrl, getListAnnouncement.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAnnouncement>;
    })
  );
}

getListAnnouncement.PATH = '/v1/api/admin-ui/announcement/list';
